import { Injectable, OnDestroy } from "@angular/core";
import { AppContainerOptions, AppContainerService } from "@mydocma/app-container";
import { AuthService, JwtAuthService } from "@mydocma/auth";
import { Customer, CustomerService } from "@mydocma/customer";
import { Project, ProjectService } from "@mydocma/project";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import { BehaviorSubject, interval, Subscription } from "rxjs";

@UntilDestroy()
@Injectable()
export class BpViewService implements OnDestroy{
    private currentCustomerSubject = new BehaviorSubject<Customer>(null);
    public currentCustomer$ = this.currentCustomerSubject.asObservable();

    private currenterProjectSubject = new BehaviorSubject<Project>(null);
    public currentProject$ = this.currenterProjectSubject.asObservable();

    private appContainerOptions: AppContainerOptions;
    private isRegistered = false;
    private configVerificationSub?: Subscription;
    private debugLogs = false;
    private expectedProjectSelection = true; 

    constructor(
        private readonly customerService: CustomerService,
        private readonly projectService: ProjectService,
        private readonly appContainerService: AppContainerService,
        private readonly authService: AuthService
      ) {

     const jwtAuthService= this.authService as any  as JwtAuthService;
      jwtAuthService.getAccessToken()

      this.customerService.currentCustomer
        .pipe(untilDestroyed(this))
        .subscribe(p => {
          this.currentCustomerSubject.next(p);
        });

        this.projectService.currentProject
        .pipe(untilDestroyed(this))
        .subscribe(p => {
            this.currenterProjectSubject.next(p);
        });
      }




      ngOnDestroy(): void {
        this.stopConfigVerification();
    }

    public closeFilter() {
        this.appContainerService.closeContentSideNav();
    }

    register(appContainer: AppContainerOptions, buttons: any[] = [], expectedProjectSelection = true) {
        if (this.isRegistered) {
            if (this.debugLogs) { console.debug('[BpViewService] register skipped - already registered'); }
            return;
        }
        this.isRegistered = true;
        this.appContainerOptions = appContainer;
        this.expectedProjectSelection = expectedProjectSelection;  // Capture per-frame intent
        appContainer.rightDrawer.visibleRightDrawerContentId = null;
        appContainer.sideNavBar.classes = ['my-bp-side-nav'];
        this.startConfigVerification();
    }

    unregister(appContainer: AppContainerOptions) {
        if (!this.isRegistered) {
            if (this.debugLogs) { console.debug('[BpViewService] unregister skipped - not registered'); }
            return;
        }
        this.stopConfigVerification();
        this.isRegistered = false;
        this.appContainerOptions = null;
    }

    registerView(component) {
        if (this.appContainerService) {
            this.appContainerService.registerFrameComponent(component);
        }
    }

    unregisterView(component) {
        if (this.appContainerService) {
            this.appContainerService.unregisterFrameComponent(component);
        }
    }

    private startConfigVerification(): void {
        if (this.configVerificationSub) { return; }
        this.configVerificationSub = interval(2000)
            .subscribe(() => {
                if (!this.appContainerOptions) { return; }
                const header: any = this.appContainerOptions.header as any;
                if (!header) { return; }

                let fixed = false;

                if (header.customerSelection !== true) {
                    header.customerSelection = true;
                    fixed = true;
                    if (this.debugLogs) {
                        console.debug('[BpViewService] restored header.customerSelection to true');
                    }
                }

                if (header.projectSelection !== this.expectedProjectSelection) {
                    header.projectSelection = this.expectedProjectSelection;
                    fixed = true;
                    if (this.debugLogs) {
                        console.debug(`[BpViewService] restored header.projectSelection to ${this.expectedProjectSelection}`);
                    }
                }
            });
    }

    private stopConfigVerification(): void {
        if (this.configVerificationSub) {
            this.configVerificationSub.unsubscribe();
            this.configVerificationSub = undefined;
        }
    }

}
